import moment from 'moment'

// Typed time entry, the way Jira does it: "1230 am", "130p", "9", "1800" all land where you meant.
//
// Order matters more than it looks. moment tries these in turn and takes the first that parses the
// whole string, so the specific patterns have to come before the loose ones -- otherwise "130p"
// matches "h a", silently drops the minutes and gives you 1:00 pm. A wrong time that looks right is
// the failure mode this page has been bitten by already (FI-2169).
const FORMATS = [
  'h:mm a',
  'hmm a',
  'hmma',
  'h:mma',
  'H:mm',
  'HH:mm',
  'Hmm',
  'HHmm',
  'h a',
  'ha',
  'h:mm',
  'H',
  'HH',
]

// "130p" -> "130pm", "1.30 PM" -> "1:30 pm"
function normalize(raw) {
  return (raw || '')
    .trim()
    .toLowerCase()
    .replace(/\./g, '')
    .replace(/\s+/g, ' ')
    .replace(/([ap])$/, '$1m')
}

// returns 'HH:mm' for the value inputs and the API, or '' when it can't be read
export function parse_time_input(raw) {
  const text = normalize(raw)
  if (!text)
    return ''

  for (const format of FORMATS) {
    const parsed = moment(text, format, true)
    if (parsed.isValid())
      return parsed.format('HH:mm')
  }
  return ''
}

// what the box shows once it's been read, so the interpretation is visible before anyone sends
export function format_time_input(value) {
  const parsed = moment(value, 'HH:mm', true)
  return parsed.isValid() ? parsed.format('h:mm a') : ''
}
